<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">Indices Vs Portfolio</strong>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-1">
          <!-- <download :tableId="'market-info'" :fileName="'market-info'"></download> -->
          <!-- <button class="btn btn-sm btn-success" @click="addNewGraph">
            <i class="fa fa-plus"></i>
          </button>-->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="'Indices Vs Portfolio'">
          <div v-for="(g, index) in graphData" v-bind:key="'graphid'+index">
            <div class="row mb5"></div>
            <companiesVsIndicesGraph @removeGraph="removeG" :graphId="g"/>
            <hr>
          </div>
          <div class="row mb5">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <!-- <download :tableId="'market-info'" :fileName="'market-info'"></download> -->
              <button class="btn btn-sm btn-success" @click="addNewGraph">
                <i class="fa fa-plus"></i> Add Graph
              </button>
            </div>
          </div>
        </v-tab>
        <v-tab :title="'Portfolios'">
          <div class="row mb5 mt5">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <!-- <download :tableId="'market-info'" :fileName="'market-info'"></download> -->
              <button class="btn btn-sm btn-success" @click="addNewPortfolio">
                <i class="fa fa-plus"></i> Add Portfolio
              </button>
            </div>
          </div>
          <vue-tabs v-model="selPortTab" direction="horizontal" @tab-change="getPortTabData">
            <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
              <addPortfolios @removeGraph="removeG" :graphId="index"/>
              <!-- <companyVsIndices @removePort="removePortfolio" :portId="index"></companyVsIndices> -->
            </v-tab>
          </vue-tabs>
        </v-tab>
        <v-tab :title="'Existing Portfolios'">
          <portfolioList :portfolios="portfoliosList"/>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import "vue-multiselect/dist/vue-multiselect.min.css";
import companiesVsIndicesGraph from "./companies-vs-indices-graph.vue";
import addPortfolios from "./addPortfolios.vue";
import portfolioList from "./portfolioList.vue";
import companyVsIndices from "./companyVsIndices.vue";
import { commonMixins } from "@/assets/mixins/common.js";
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
export default {
  mounted() {},
  mixins: [commonMixins],
  components: { VueTabs, VTab, companiesVsIndicesGraph, companyVsIndices, addPortfolios, portfolioList },
  created() {},
  data() {
    return {
      graph: 1,
      graphCnt: 1,
      graphData: [1],
      selTab: "",
      selPortTab: "",
      tabs: [{ id: "portfolio-1", name: "Portfolio" }],
      portfoliosList: []
    };
  },
  methods: {
    addNewGraph() {
      this.graphCnt = this.graphCnt + 1;
      this.graphData.push(this.graphCnt);
    },
    removeG(obj) {
      console.log(obj.graphId, this.graphData.indexOf(obj.graphId));
      console.log(this.graphData);
      this.graphData.splice(this.graphData.indexOf(obj.graphId), 1);
      console.log(this.graphData);
    },
    getTabData(tabIndex, newTab, oldTab) {
      if(tabIndex === 2){
        this.getSavedPortFolios();
      }
    },
    addNewPortfolio() {
      this.tabs.push({
        id: "portfolio" + (this.tabs.length + 1),
        name: "Portfolio " + this.tabs.length
      });
    },
    getPortTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab, oldTab);
      this.selPortTab = tabIndex;      
    },
    removePortfolio(obj) {
      console.log("Remove Portfolio",obj.portId);      
      // if(this.tabs.length === 2){
      //   this.selPortTab = 0; //this.tabs[0].name;
      // }
      this.selPortTab = parseInt(obj.portId-1);
      this.tabs.splice(obj.portId, 1);
    },
    getSavedPortFolios(){
      let _this = this;
      _this.priceVsIndexList = [];
      _this.selInd = "";
      http.get("getSavePortfolios", {}, function(error, response) {
        console.log("getIndices Data", response);
        _this.portfoliosList = response;
      });
    }
  },
  mounted() {},
  watch: {}
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/indices-data/companiesVsPortfolio.vue